<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {CellKey} from "@/modules/redactor/models/cells/CellKey";

export default {
  name: "r-cell-key",
  props: {
    model: VueTypes.instanceOf(CellKey),
    label: VueTypes.string.def("CellKey:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return CellKey.getValues();
    }
  }
}
</script>